/**
 * Normaliza qualquer formato de evento recebido pelo Socket.IO.
 *
 * Formatos aceitos:
 * 1. Envelope canônico:      `{ id, type, version, occurredAt, data }`
 * 2. Wrapper legado:         `{ event, data }`
 * 3. Payload plano legado:   `{ pedidoId, status, ... }`
 *
 * O resultado é sempre `{ id, type, version, occurredAt, data, legacyType }`,
 * eliminando o problema de "evento dentro de evento" que impedia o frontend de
 * enxergar `data.pedidoId`.
 */
import { canonicalTypeFor } from './eventTypes';

const isObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const normalizeRealtimeEvent = (eventName, payload) => {
  if (!eventName) return null;

  const declaredType = canonicalTypeFor(eventName);
  const raw = isObject(payload) ? payload : {};

  // Envelope canônico
  if (raw.type && raw.data !== undefined) {
    return {
      id: raw.id || null,
      type: canonicalTypeFor(raw.type),
      version: raw.version || 1,
      occurredAt: raw.occurredAt || null,
      data: isObject(raw.data) ? raw.data : {},
      legacyType: raw.type === eventName ? null : eventName,
    };
  }

  // Wrapper legado `{ event, data }`
  if (raw.event && raw.data !== undefined) {
    return {
      id: null,
      type: canonicalTypeFor(raw.event),
      version: 1,
      occurredAt: null,
      data: isObject(raw.data) ? raw.data : {},
      legacyType: raw.event === eventName ? null : eventName,
    };
  }

  // Payload plano
  return {
    id: null,
    type: declaredType,
    version: 1,
    occurredAt: null,
    data: raw,
    legacyType: declaredType === eventName ? null : eventName,
  };
};

export default normalizeRealtimeEvent;
